import { useEffect, useRef, useState } from "react";
import { Constants } from "./Constants";
import LoaderForSearch from "../Components/Common/LoaderForSearch";
import { useDebounce } from "../Components/useDebounce";
import { AESEncryption, alphaNumericUppercase, alphaNumericUppercasePaste, ApiResDecrypt, decryptData, encryptData } from "./CommonMethods";
import axiosInstance from "./axiosInstance";
import { Partner_Reports } from "../Configuration/Partner_URL";
import { Client_Search } from "../Configuration/API_URL";


function CommonSearch({ setDataCount = () => {}, setClientCode, clientCode, label = Constants.Client_Name, placeholder = "Search here..." }) {

    // const [clientCode, setClientCode] = useState("");
    const [clientName, setClientName] = useState('');
    const [loader, setLoader] = useState(false);
    const clientInputRef = useRef(null);
    const [show, setShow] = useState(false);
    const [scripNames, setScripNames] = useState([]);
    const [submitNameError, setSubmitNameError] = useState(false);
    const [clientList, setClientList] = useState([]);
    const [scrollLoader, setScrollLoader] = useState(false);
    const [page, setPage] = useState(1);
    const [count, setCount] = useState();
    const [nameError, setNameError] = useState(false);
    const userType = localStorage.getItem("partnerType").toLowerCase();
    const [searchText, setSearchText] = useState("");
    const partnerRoleNew = localStorage.getItem("partnerRoleNew")?.toLowerCase();

    const debouncedValue = useDebounce(searchText, 1000);
    useEffect(() => {
        handleClientName(debouncedValue);
    }, [debouncedValue]);

    async function searchApiDetail(code, NoPage) {
        let payloadValue = {
            keyword: code,
            Status: "",
            PageNo: NoPage,
            PageSize: 10,
        };
        const partnerPayload = {
            clientCode: code,
            page: NoPage,
            pageSize: 10,
        };

        const encPayload =
            userType === "partner" || partnerRoleNew === "partner"
                ? encryptData(JSON.stringify(partnerPayload))
                : AESEncryption(payloadValue);

                console.log(payloadValue, "payloadSearch");
                
        try {
            const getSearchDetail = await axiosInstance.post(
                userType === "partner" || partnerRoleNew === "partner"
                    ? Partner_Reports.Client_Search_Partner_URL
                    : Client_Search.Search_URL,
                userType === "partner" || partnerRoleNew === "partner" ? encPayload : `"${encPayload}"`,
            );

            const res =
                userType === "partner" || partnerRoleNew === "partner"
                    ? JSON.parse(decryptData(getSearchDetail?.data))
                    : ApiResDecrypt(getSearchDetail?.data);

            if (res?.status === 0) {
                setCount(res?.data?.TotalCount);
                setNameError(false);
                if (page > 1) {
                    setClientList((prev) => {
                        return [...prev, ...res?.data?.clients];
                    });
                } else {
                    setClientList(res?.data?.clients);
                }
            } else {
                setNameError(res?.message);
            }
        } catch (error) {
        } finally {
            setScrollLoader(false);
        }
    }
    function handleClientName(data) {
        if (data) {
            searchApiDetail(data, 1);
            setScrollLoader(true);
            setNameError(false);
            setClientList([]);
            setPage(1);
        }
    }

    useEffect(() => {
        if (page > 1) {
            searchApiDetail(searchText, page);
        }
    }, [page]);

    const handleScroll = async (e) => {
        const a = e.target;
        if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
            if (!(count <= 10 * page)) {
                setPage((prev) => prev + 1);
                setScrollLoader(true);
            }
        }
    };

    return (
        <div className="form-group">
            <label className="form-label">{label}</label>
            <div className="rm-custom-dropdown">
                <input
                    type="text"
                    name="search-text"
                    className="input-st"
                    placeholder={placeholder}
                    autoComplete="off"
                    value={searchText}
                    ref={clientInputRef}
                    onChange={(e) => {
                         const value = alphaNumericUppercase(e.target.value, 50);
                        setSearchText(value);
                        setClientCode("")
                        setShow(true);
                        setSubmitNameError(false);
                        setScripNames([]);
                        setDataCount([]);
                        if (value.length === 0) {
                            setClientName("");
                            setNameError(false);
                            setClientList([])
                            setShow(false)
                        }
                    }}
                    // onInput={(e) => alphaNumericUppercase(e.target.value, 50)}                 
                    onPaste={alphaNumericUppercasePaste(50)}

                    // onInput={(e) => {
                    //     const start = e.target.selectionStart;
                    //     const end = e.target.selectionEnd;
                    //     let input = e.target.value;
                    //     input = input
                    //         .toUpperCase()
                    //         .replace(/[^A-Z0-9\s]/g, "")
                    //         .replace(/\s+/g, " ")
                    //         .trimStart()
                    //         .slice(0, 100);

                    //     e.target.value = input;
                    //     e.target.setSelectionRange(start, end);
                    // }}
                />
                <button
                    className="rm-dropdown-btn"
                    onClick={() => setShow(!show)}
                >
                    <span className="icon-right-arrow-triangle"></span>
                </button>
                {show && (
                    <>
                        <ul
                            className="rm-mapping-ap border-0"
                            onScroll={(e) => handleScroll(e)}
                        >
                            {clientList &&
                                clientList.map((item, i) => (
                                    <li
                                        key={i}
                                        className="rm-maping-item-wrapper"
                                        onClick={() => {
                                             setSearchText(item.clientCode); 
                                            setClientCode(item?.clientCode);
                                            setClientName(item?.clientCode)
                                            setShow(false);
                                            setScripNames([]);
                                        }}
                                    >
                                        {userType === "partner" || partnerRoleNew === "partner" ?
                                            <>
                                                <div> {item?.clientName}</div>
                                                <div> {item?.clientCode}</div>
                                            </>
                                            :
                                            <>
                                                <div> {item?.clientname}</div>
                                                <div> {item?.clientCode}</div>
                                            </>
                                        }
                                    </li>
                                ))}
                            {scrollLoader && !loader && (
                                <div className="loader-center">
                                    <LoaderForSearch />
                                </div>
                            )}
                            {nameError && !scrollLoader && (
                                <li
                                    className="rm-maping-item-wrapper"
                                    style={{
                                        borderBottom: "none",
                                        fontSize: "12px",
                                    }}
                                >
                                    {nameError}
                                </li>
                            )}
                        </ul>
                    </>
                )}
            </div>
            {submitNameError && (
                <span className="to-date-error" style={{ bottom: "-8px" }}>{submitNameError}</span>
            )}
        </div>
    )
}

export default CommonSearch;